import CustomLexiconAddMappingContainer from './CustomLexiconAddMappingContainer';
export default CustomLexiconAddMappingContainer;
